/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useCallback, useRef } from 'react'
import { withTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import styles from './ReviewConfirmation.module.scss'
import ChangeOfAddress from './ChangeOfAddress'
import ContactInformation from './ContactInformation'
import EVLevyBanner from './EVLevyBanner'
import PlateOwnerInfo from './PlateOwnerInfo'
import PermitsListTable from '../../PermitsList/components/PermitsListTable'
import { postTransactionAction } from 'redux/reducers/apiReducers/postTransactionReducer'
import { screenLoadingAction, editFromConfirmationAction } from 'redux/actions'
import BackAnchor from '../../../../shared/components/BackAnchor'
import BackNextButtonWithDisable from '../../../../shared/components/BackNextButtonWithDisable'

const ReviewConfirmationView = ({ t, i18n, setIsError }) => {
  const [confirmChecked, setConfirmChecked] = useState(false)
  const [checkboxMessage, setCheckbocMessage] = useState(false)
  const [fulfillmentStatusError, setFulfillmentStatusError] = useState()
  const [errMsg, setErrMsg] = useState('')
  const dispatch = useDispatch()
  const history = useHistory()

  const { permits, fullName, masterNumber, emailAddress, phoneNumber, addressUpdate } = useSelector((state) => state.app)
  const userIdentifier = useSelector((state) => state.register.uniqueID)

  const [loading, setLoading] = useState(false)
  const isProcessing = useRef(false)

  useEffect(() => {
    try {
      if (!fullName || !masterNumber) {
        history.push(`/${i18n.language}${t('routes.your_info')}`)
      } else {
        dispatch(editFromConfirmationAction(false))
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [])

  const location = useLocation()

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const fulfillmentStatus = params.get('fulfillmentStatus')
    if (fulfillmentStatus === 'SENTFORPAYMENT') {
      setFulfillmentStatusError('review_confirmation.server_error')
    }
  }, [location])

  const getTransactionData = () => {
    try {
      let businessData = {}
      let contactInformation = {
        fullName,
        emailAddress,
        phoneNumber,
      }
      businessData['addressUpdate'] = addressUpdate
      businessData['masterNumber'] = masterNumber
      businessData['permits'] = permits
      businessData['contactInformation'] = contactInformation
      let data = {}
      data['businessData'] = JSON.stringify(businessData)
      data['businessServiceType'] = 'RENEWVEHICLEPERMIT'
      data['lang'] = i18n.language.toString()
      data['useridentifier'] = userIdentifier.toString()
      return data
    } catch (err) {
      console.log(err)
      throw err
    }
  }

  const confirmationClick = () => {
    if (isProcessing.current) return; // Prevent further clicks

    isProcessing.current = true; // Lock immediately to prevent race conditions

    try {
      if (confirmChecked && !loading) {
        setLoading(true)
        setCheckbocMessage(false)
        dispatch(screenLoadingAction())
        dispatch(postTransactionAction(getTransactionData()))
          .then((res) => {
            let transId = res['data']['id']
            let uuid = res['data']['useridentifier']
            let paymentURL = `/services/transactionservice/api/nspayredirect?transId=${transId}&transOwner=${uuid}`

            dispatch(screenLoadingAction())
            window.location.assign(`${window.location.origin}${paymentURL}`)
          })
          .catch((e) => {
            dispatch(screenLoadingAction())
            console.log(e)
            setErrMsg('review_confirmation.server_error')
          })
      } else {
        setCheckbocMessage(true)
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    } finally {
      isProcessing.current = false // Unlock clicks after the process is complete
    }
  }

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)

  const updateIsMobile = useCallback(() => {
    setIsMobile(window.innerWidth <= 768)
  }, [])

  useEffect(() => {
    window.addEventListener('resize', updateIsMobile)
    return () => {
      window.removeEventListener('resize', updateIsMobile)
    }
  }, [updateIsMobile])

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12">
          <BackAnchor backPath={'routes.contact_info'} />
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12">
          <h1>{t('review_confirmation.title')}</h1>
        </div>
      </div>
      {fulfillmentStatusError && (
        <div className="row">
          <div className="col-xs-12" style={{ display: 'flex' }}>
            <i
              className={['fa fa-exclamation-circle fa-2x', styles['exclamation_position'], styles['exclamation_color']].join(' ')}
              aria-hidden="true"
            />
            <div className={styles['error_message']} style={{ marginLeft: '1rem' }}>
              <div className="form-group has-error">
                <div>
                  <h3 className="help-block">{t(fulfillmentStatusError)}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-xs-12 col-md-10">
          <EVLevyBanner />
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-10">
          <h2>{t('review_confirmation.plate_owner_information')}</h2>
          <PlateOwnerInfo t={t} fullName={fullName} masterNumber={masterNumber} isMobile={isMobile} />
          <ChangeOfAddress isMobile={isMobile} />
          <ContactInformation isMobile={isMobile} />
        </div>
      </div>
      <PermitsListTable reviewConfirmation={true} />
      <div className="row">
        <div className="col-xs-12 col-lg-10">
          <button
            style={{ float: 'right', marginTop: '20px', marginBottom: '0px' }}
            className="btn-lg btn-secondary"
            onClick={() => {
              localStorage.setItem('backAction', 'review')
              history.push(`/${i18n.language}${t('routes.add_permit')}`)
            }}
            value={t('permits_list.add_another_renewal')}
            name={t('permits_list.add_another_renewal')}
          >
            {t('permits_list.add_another_renewal')}
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-lg-12">
          <h3>{t('review_confirmation.confirmation')}</h3>
          {t('review_confirmation.please_verify')}
          <br />
          {t('review_confirmation.your_confirmation')}
          <ul style={{ marginTop: '2px' }}>
            <li>{t('review_confirmation.you_consent_to')}</li>
            <li>
              {t('review_confirmation.you_are_in_agreement')}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={
                  i18n.language === 'en'
                    ? 'https://novascotia.ca/sns/services/help/terms-of-use.asp'
                    : 'https://novascotia.ca/sns/services/help/terms-of-use-fr.asp'
                }
              >
                {t('review_confirmation.terms_of_use')}
                <span className="ns-visually-hidden">{t('shared.opens_new_tab')}</span>
              </a>
              {t('review_confirmation.for_this_transaction')}
            </li>
          </ul>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <div className="ns-checkboxes__item">
            <input
              className="ns-checkboxes__input"
              type="checkbox"
              id="ConfirmationCheckBox"
              value="confirm_check"
              onChange={(e) => {
                setConfirmChecked(e.currentTarget.checked)
              }}
              onBlur={() => {
                confirmChecked ? setCheckbocMessage(false) : setCheckbocMessage(true)
              }}
              checked={confirmChecked}
            />
            <label className="ns-label ns-checkboxes__label confirm_check_input" htmlFor="ConfirmationCheckBox">
              <span className="ns-label-span">
                <b>{t('review_confirmation.yes_information_is_correct')}</b>
              </span>
            </label>
          </div>
          {checkboxMessage && (
            <div className="form-group has-error help-block">
              <i
                style={{ margin: '3px 5px 0 0' }}
                className={['fa fa-exclamation-circle', styles['exclamation_color']].join(' ')}
                aria-hidden="true"
              ></i>
              {t('review_confirmation.confirm_check_error')}
            </div>
          )}
        </div>
      </div>
      <button style={{ margin: '20px auto' }} className="btn-lg btn-success" onClick={confirmationClick} disabled={loading}>
        {t('review_confirmation.continue_to_payment')}
      </button>
      {errMsg !== '' && (
        <div className={styles['error_message']}>
          <div className="form-group has-error">
            <div className="help-block">
              <i
                className={['fa fa-exclamation-circle', styles['exclamation_position'], styles['exclamation_color']].join(' ')}
                aria-hidden="true"
              />{' '}
              {t(errMsg)}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default withTranslation('common')(ReviewConfirmationView)
